import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import inspectIcon from "../../assets/images/profile-2user.svg";
import BriefCase from "../../assets/images/briefcase.svg";
import Clipboard from "../../assets/images/clipboard.svg";

const Stats = ({ surveys, clients, surveyors }) => {
  return (
    <Row>
      <Col md="4">
        <Card className="card-main media mb-3">
          <div className="media-body">
            <h3>Inspectors</h3>
            <div className="count">{surveyors || 0}</div>
          </div>
          <div className="icon">
            <img src={inspectIcon} alt="" />
          </div>
        </Card>
      </Col>
      <Col md="4">
        <Card className="card-main media bg-red  mb-3">
          <div className="media-body">
            <h3>Clients</h3>
            <div className="count">{clients || 0}</div>
          </div>
          <div className="icon">
            <img src={BriefCase} alt="" />
          </div>
        </Card>
      </Col>
      <Col md="4">
        <Card className="card-main media  bg-indigo  mb-3">
          <div className="media-body">
            <h3>Surveys</h3>
            <div className="count">{surveys || 0}</div>
          </div>
          <div className="icon">
            <img src={Clipboard} alt="" />
          </div>
        </Card>
      </Col>
    </Row>
  );
};

export default Stats;
